import React from 'react';
import { Empty as AntEmpty } from 'antd';
function Empty(props) {
    return React.createElement(AntEmpty, Object.assign({ image: AntEmpty.PRESENTED_IMAGE_SIMPLE }, props));
}
export { Empty };
